export const WebsiteCard = ({ image, title, description, url }) => {
    return (
        <div
            className="card-container"
            onClick={() => {
                window.open(url,"_blank");
            }}
        >
            <img
                src={image}
                alt=""
                className="card-img"
            />
            <div className="card-caption">{title}</div>
            <div className="card-descr">{description}</div>
        </div>
    );
}
